
// @ts-nocheck


export const localeCodes =  [
  "en",
  "pl",
  "de",
  "ru",
  "es",
  "fr",
  "it",
  "br"
]

export const localeLoaders = {
  "en": [{ key: "../locales/en.ts", load: () => import("../locales/en.ts?hash=a00dcd52&locale=en" /* webpackChunkName: "locale__app_locales_en_ts" */), cache: false }],
  "pl": [{ key: "../locales/pl.ts", load: () => import("../locales/pl.ts?hash=e3a133be&locale=pl" /* webpackChunkName: "locale__app_locales_pl_ts" */), cache: false }],
  "de": [{ key: "../locales/de.ts", load: () => import("../locales/de.ts?hash=19021c06&locale=de" /* webpackChunkName: "locale__app_locales_de_ts" */), cache: false }],
  "ru": [{ key: "../locales/ru.ts", load: () => import("../locales/ru.ts?hash=50dd3657&locale=ru" /* webpackChunkName: "locale__app_locales_ru_ts" */), cache: false }],
  "es": [{ key: "../locales/es.ts", load: () => import("../locales/es.ts?hash=5c9cb3eb&locale=es" /* webpackChunkName: "locale__app_locales_es_ts" */), cache: false }],
  "fr": [{ key: "../locales/fr.ts", load: () => import("../locales/fr.ts?hash=ba6ed19a&locale=fr" /* webpackChunkName: "locale__app_locales_fr_ts" */), cache: false }],
  "it": [{ key: "../locales/it.ts", load: () => import("../locales/it.ts?hash=9fd089d6&locale=it" /* webpackChunkName: "locale__app_locales_it_ts" */), cache: false }],
  "br": [{ key: "../locales/br.ts", load: () => import("../locales/br.ts?hash=c0045cbc&locale=br" /* webpackChunkName: "locale__app_locales_br_ts" */), cache: false }]
}

export const vueI18nConfigs = [
  
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "en",
      "name": "English",
      "language": "en",
      "icon": "en-flag",
      "icuCode": "en_US",
      "files": [
        "/app/locales/en.ts"
      ]
    },
    {
      "code": "pl",
      "name": "Polski",
      "language": "pl",
      "icon": "pl-flag",
      "icuCode": "pl_PL",
      "files": [
        "/app/locales/pl.ts"
      ]
    },
    {
      "code": "de",
      "name": "Deutsch",
      "language": "de",
      "icon": "de-flag",
      "icuCode": "de_DE",
      "files": [
        "/app/locales/de.ts"
      ]
    },
    {
      "code": "ru",
      "name": "Русский",
      "language": "ru",
      "icon": "ru-flag",
      "icuCode": "ru_RU",
      "files": [
        "/app/locales/ru.ts"
      ]
    },
    {
      "code": "es",
      "name": "Español",
      "language": "es",
      "icon": "es-flag",
      "icuCode": "es_ES",
      "files": [
        "/app/locales/es.ts"
      ]
    },
    {
      "code": "fr",
      "name": "Français",
      "language": "fr",
      "icon": "fr-flag",
      "icuCode": "fr_FR",
      "files": [
        "/app/locales/fr.ts"
      ]
    },
    {
      "code": "it",
      "name": "Italiano",
      "language": "it",
      "icon": "it-flag",
      "icuCode": "it_IT",
      "files": [
        "/app/locales/it.ts"
      ]
    },
    {
      "code": "br",
      "name": "Português (Brasil)",
      "language": "pt-BR",
      "icon": "br-flag",
      "icuCode": "pt_BR",
      "files": [
        "/app/locales/br.ts"
      ]
    }
  ],
  "defaultLocale": "en",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "no_prefix",
  "lazy": true,
  "langDir": "./locales",
  "detectBrowserLanguage": {
    "alwaysRedirect": true,
    "cookieCrossOrigin": true,
    "cookieDomain": null,
    "cookieKey": "lang-atp",
    "cookieSecure": false,
    "fallbackLocale": "en",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "https://attendee.clickmeeting.com",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "en",
    "name": "English",
    "language": "en",
    "icon": "en-flag",
    "icuCode": "en_US",
    "files": [
      {
        "path": "/app/locales/en.ts"
      }
    ]
  },
  {
    "code": "pl",
    "name": "Polski",
    "language": "pl",
    "icon": "pl-flag",
    "icuCode": "pl_PL",
    "files": [
      {
        "path": "/app/locales/pl.ts"
      }
    ]
  },
  {
    "code": "de",
    "name": "Deutsch",
    "language": "de",
    "icon": "de-flag",
    "icuCode": "de_DE",
    "files": [
      {
        "path": "/app/locales/de.ts"
      }
    ]
  },
  {
    "code": "ru",
    "name": "Русский",
    "language": "ru",
    "icon": "ru-flag",
    "icuCode": "ru_RU",
    "files": [
      {
        "path": "/app/locales/ru.ts"
      }
    ]
  },
  {
    "code": "es",
    "name": "Español",
    "language": "es",
    "icon": "es-flag",
    "icuCode": "es_ES",
    "files": [
      {
        "path": "/app/locales/es.ts"
      }
    ]
  },
  {
    "code": "fr",
    "name": "Français",
    "language": "fr",
    "icon": "fr-flag",
    "icuCode": "fr_FR",
    "files": [
      {
        "path": "/app/locales/fr.ts"
      }
    ]
  },
  {
    "code": "it",
    "name": "Italiano",
    "language": "it",
    "icon": "it-flag",
    "icuCode": "it_IT",
    "files": [
      {
        "path": "/app/locales/it.ts"
      }
    ]
  },
  {
    "code": "br",
    "name": "Português (Brasil)",
    "language": "pt-BR",
    "icon": "br-flag",
    "icuCode": "pt_BR",
    "files": [
      {
        "path": "/app/locales/br.ts"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
